import { createFileRoute, Navigate, useMatches } from '@tanstack/react-router';

// relative imports
import Dashboard from '../../components/dashboard/Dashboard';
import { useAccountConfig } from '../../components/providers/AccountConfigProvider';
import { useAccount } from '../../components/providers/AccountProvider';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

function AppDashboard() {
  const accountData = useAccount();
  const { currentAccount = {} } = accountData || {};
  const accountType = currentAccount.type;
  const accountConfigData = useAccountConfig();
  const { accountConfig = {} } = accountConfigData || {};

  // Check if we're on a client route - if so, don't render the main dashboard
  const matches = useMatches();
  const isClientRoute = matches.some((match) => match.staticData.isClientRoute);

  if (isClientRoute) {
    return null; // Don't render anything when on client route
  }

  if (
    accountType === 'Accounting' &&
    accountConfig.id === 'ledgible-defaultStaking'
  ) {
    return <Navigate to={`/staking` as any} replace />;
  }

  return <Dashboard />;
}

export const Route = createFileRoute('/_authenticated/')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: AppDashboard,
  staticData: {
    configPageId: 'dashboard',
    meta: {
      title: 'Dashboard | Ledgible',
    },
  },
});
